module.exports = __webpack_public_path__ + "img/TADA.497c6f46.png";